module.exports = __webpack_public_path__ + "img/saldo-icon.1714c1f4.svg";